<app-nav-steps *ngIf="!isReadOnly"></app-nav-steps>

<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ 'installation-data.site-electricity-meterdata' | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">{{ 'technician-data.technical-data-title' | translate }}</div>
  </div>

  <div *ngIf="installationTechnicalDataFG" class="technical-data-container">
    <form
      [formGroup]="installationTechnicalDataFG"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <app-review-section
        [title]="'facilities-data.base-data-title' | translate"
        [tooltip]="'tooltips.technician-form.base-data' | translate"
        [showTooltip]="infoBubblesData?.showBaseDataHeaderInfo"
        [sectionId]="baseDataSectionIdentifier"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div class="form-background">
          <div class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label class="ui-g-5 field-label text-right-align required" for="base-data-facility-type">
                {{ 'facilities-data.form-fields.facility-type' | translate }}
              </label>
              <p-dropdown
                [options]="facilityTypes"
                formControlName="facilityType"
                id="base-data-facility-type"
                placeholder="-Select-"
                [readonly]="true">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{
                      (item['value'] === 'construction_site'
                        ? item.label
                        : 'lookup.' + facilityTypeKey + '.options.' + item['value'] + '.name'
                      ) | translate
                    }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{
                        (option['value'] === 'construction_site'
                          ? option.label
                          : 'lookup.' + facilityTypeKey + '.options.' + option['value'] + '.name'
                        ) | translate
                      }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div
              *ngIf="installationTechnicalDataFG.get('meterSwitch') && !installationTechnicalDataFG.get('meterSwitch').value"
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label class="ui-g-5 field-label text-right-align" for="internal-power-sitecon">
                {{ 'site-electricity-installation-technical-data.internal-power-sitecon' | translate }}
              </label>
              <p-dropdown
                [options]="internalPowerSiteConTypes"
                formControlName="internalPowerSiteCon"
                id="internal-power-sitecon"
                placeholder="-Select-"
                [readonly]="isReadOnly">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{ 'lookup.' + internalPowerSiteConTypeKey + '.options.' + item['value'] + '.name' | translate }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + internalPowerSiteConTypeKey + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div
              *ngIf="installationTechnicalDataFG.get('meterSwitch') && installationTechnicalDataFG.get('meterSwitch').value"
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label class="ui-g-5 field-label text-right-align" for="external-power-sitecon">
                {{ 'site-electricity-installation-technical-data.external-power-sitecon' | translate }}
              </label>
              <p-dropdown
                [options]="externalPowerSiteConTypes"
                (onChange)="onSelectExternalPowerSiteCon($event)"
                formControlName="externalPowerSiteCon"
                id="external-power-sitecon"
                placeholder="-Select-"
                [readonly]="isReadOnly">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{ 'lookup.' + externalPowerSiteConTypeKey + '.options.' + item['value'] + '.name' | translate }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + externalPowerSiteConTypeKey + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>

          <div class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows place-of-meter">
              <label class="ui-g-5 field-label text-right-align">{{ 'facilities-data.form-fields.place-of-meter' | translate }}</label>
            </div>
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows switch">
              <label class="ui-g-5 field-label text-right-align">
                {{ 'site-electricity-installation-technical-data.internal-power-sitecon' | translate }}
              </label>
              <p-inputSwitch appEnterClick formControlName="meterSwitch" [readonly]="isReadOnly"></p-inputSwitch>
              <label class="text-right-align external">
                {{ 'site-electricity-installation-technical-data.external-power-sitecon' | translate }}
              </label>
            </div>
            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
              *ngIf="installationTechnicalDataFG.get('siteConPowerSubtype')">
              <label class="ui-g-5 field-label text-right-align" for="sitecon-power-subtype">
                {{ 'site-electricity-installation-technical-data.sitecon-power-subtype' | translate }}
              </label>
              <p-dropdown
                [options]="siteConPowerSubTypes"
                [formControl]="installationTechnicalDataFG.controls['siteConPowerSubtype']"
                id="sitecon-power-subtype"
                placeholder="-Select-"
                readonly>
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{ 'lookup.' + siteConPowerSubTypeKey + '.options.' + item['value'] + '.name' | translate }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + siteConPowerSubTypeKey + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>

          <div class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
              <label for="crane-in-place-check" class="ui-g-5"></label>
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="isReadOnly"
                formControlName="craneInPlaceCheckbox"
                id="crane-in-place-check"
                label="{{ 'site-electricity-installation-technical-data.crane-in-place-checkbox' | translate }}"></p-checkbox>
            </div>
          </div>
        </div>
      </app-review-section>

      <app-review-section
        [title]="'technician-data.power-connection-title' | translate"
        [tooltip]="'tooltips.technician-form.power-connection' | translate"
        [showTooltip]="infoBubblesData?.showPowerConnectionHeaderInfo"
        [sectionId]="powerConnectionSectionIdentifier"
        [applicationId]="applicationId"
        [isDetailsView]="isDetailsView">
        <div class="form-background">
          <div class="ui-g-12 form-rows">
            <div class="ui-g-6 field-rows">
              <label class="ui-g-5 field-label text-right-align required" for="site-con-current">
                {{ 'technician-data.form-fields.swkn-required-fuse-power' | translate }}
              </label>
              <p-dropdown
                [options]="siteConCurrentTypes"
                [readonly]="isReadOnly"
                formControlName="siteConCurrent"
                (onChange)="onSelectSiteConCurrent($event)"
                id="site-con-current"
                placeholder="-Select-">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{ 'lookup.' + siteConCurrentTypeKey + '.options.' + item['value'] + '.name' | translate }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + siteConCurrentTypeKey + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
      </app-review-section>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <div class="meter-data">
          <app-meter-data
            [formType]="currentFormType"
            [selectedSiteConCurrentValue]="selectedSiteConCurrentValue"
            [isReadOnly]="isReadOnly"
            [meterData]="meterData"
            [isDetailsView]="isDetailsView"
            [applicationId]="applicationId"></app-meter-data>
        </div>
      </div>

      <div *ngIf="!isReadOnly && !isDetailsView" class="ui-g-12 submit-button-section bottom-padding">
        <div class="ui-g-6 button-group">
          <button
            (click)="saveFormData()"
            [disabled]="installationTechnicalDataFG.invalid"
            class="submit-button"
            label="{{ 'basic-profile.jurisdiction.proceed' | translate | uppercase }}"
            pButton></button>
        </div>
      </div>
    </form>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
